// Code generated by cast-iron. DO NOT EDIT.

// tslint:disable:max-line-length
// tslint:disable:quotemark
// tslint:disable:no-empty-interface

import { Observable } from 'rxjs';

export type Allergen = number;
export const AllergenToParent = new Map<Allergen, Allergen|null>([[1000, null], [1001, 1000], [1002, 1000], [1003, 1000], [1004, 1000], [1005, 1000], [1100, null], [1101, 1100], [1200, null], [1201, 1200], [1300, null], [1301, 1300], [1400, null], [1401, 1400], [1500, null], [1501, 1500], [1600, null], [1601, 1600], [1700, null], [1701, 1700], [1702, 1700], [1703, 1700], [1704, 1700], [1705, 1700], [1706, 1700], [1707, 1700], [1708, 1700], [1709, 1700], [1800, null], [1801, 1800], [1900, null], [1901, 1900], [2000, null], [2001, 2000], [2100, null], [2101, 2100], [2200, null], [2201, 2200], [2300, null], [2301, 2300]]);
export const AllergenToName = new Map<Allergen, string>([[1000, "žita, ki vsebujejo gluten"], [1001, "neopredeljena žita, ki vsebujejo gluten"], [1002, "pšenica (pira, horasan)"], [1003, "rž"], [1004, "ječmen"], [1005, "oves"], [1100, "raki"], [1101, "raki"], [1200, "jajca"], [1201, "jajca"], [1300, "ribe"], [1301, "ribe"], [1400, "arašidi (kikiriki)"], [1401, "arašidi (kikiriki)"], [1500, "zrnje soje"], [1501, "zrnje soje"], [1600, "mleko"], [1601, "mleko"], [1700, "oreški"], [1701, "neopredeljeni oreščki"], [1702, "mandlji"], [1703, "lešniki"], [1704, "orehi"], [1705, "indijski oreščki"], [1706, "ameriški orehi"], [1707, "brazilski oreščki"], [1708, "pistacija"], [1709, "makadamija"], [1800, "zelena"], [1801, "zelena"], [1900, "gorčično seme"], [1901, "gorčično seme"], [2000, "sezamovo seme"], [2001, "sezamovo seme"], [2100, "žveplov dioksid/sulfit"], [2101, "žveplov dioksid/sulfit"], [2200, "volčji bob "], [2201, "volčji bob "], [2300, "mehkužci"], [2301, "mehkužci"]]);

export enum Category {Starch = 1, Milk = 2, Meat = 3, Vegetable = 5, Fruit = 6, Liquid = 9, Egg = 10, Fish = 11}
export const AllCategories = [Category.Starch, Category.Milk, Category.Meat, Category.Vegetable, Category.Fruit, Category.Liquid, Category.Egg, Category.Fish];

export enum Component {Protein = 1, AnimalProtein = 2, VegetableProtein = 3, BranchedChainedAminoAcids = 4, Isoleucine = 5, Leucine = 6, Lysine = 7, TotalAminoAcids = 8, Phenylalanine = 9, Aspartame = 10, Gluten = 11, Fat = 12, SaturatedFattyAcids = 13, MonounsaturatedFattyAcids = 14, LinoleicFattyAcid = 15, LinolenicFattyAcid = 16, ArachidonicAcid = 17, EicopentaenoicAcid = 18, DocosahexaenoicAcid = 19, MyristoleicFattyAcid = 20, PalmitoleicFattyAcid = 21, StearicFattyAcid = 22, OleicFattyAcid = 23, TotalOmega3 = 24, TotalOmega6 = 25, TotalPolyunsaturatedFattyAcids = 26, Cholesterol = 27, TotalCarbohydrates = 28, TotalSugars = 29, SimpleSugars = 30, FreeSugars = 31, Fructose = 32, Galactose = 33, Glucose = 34, Lactose = 35, Sucrose = 36, Starch = 37, TotalDietaryFibre = 38, CrudeDietaryFibre = 39, InsolubleDietaryFibre = 40, SolubleDietaryFibre = 41, VitaminA = 42, AlphaCarotene = 43, BetaCarotene = 44, GammaCarotene = 45, VitaminD = 46, VitaminE = 47, VitaminK = 48, VitaminC = 49, B1Thiamin = 50, B2Riboflavin = 51, B3Niacin = 52, B6Piridoksin = 53, B5PantothenicAcid = 54, B7Biotin = 55, B9FolicAcid = 56, B12Cobalamin = 57, Sodium = 58, Chloride = 59, Potassium = 60, Calcium = 61, Magnesium = 62, Phosphorus = 63, Iron = 64, Iodine = 65, Fluoride = 66, Zink = 67, Copper = 68, Manganese = 69, Chronium = 70, Molybdenum = 71, Proline = 72, Selenium = 73, Water = 74, Alcohol = 75, TotalOrac = 76, GlycemicIndex = 77, GlycemicLoad = 78, Color = 79, Probio = 80, Co2e = 81, Energy = 82}
export const AllComponents = [Component.Protein, Component.AnimalProtein, Component.VegetableProtein, Component.BranchedChainedAminoAcids, Component.Isoleucine, Component.Leucine, Component.Lysine, Component.TotalAminoAcids, Component.Phenylalanine, Component.Aspartame, Component.Gluten, Component.Fat, Component.SaturatedFattyAcids, Component.MonounsaturatedFattyAcids, Component.LinoleicFattyAcid, Component.LinolenicFattyAcid, Component.ArachidonicAcid, Component.EicopentaenoicAcid, Component.DocosahexaenoicAcid, Component.MyristoleicFattyAcid, Component.PalmitoleicFattyAcid, Component.StearicFattyAcid, Component.OleicFattyAcid, Component.TotalOmega3, Component.TotalOmega6, Component.TotalPolyunsaturatedFattyAcids, Component.Cholesterol, Component.TotalCarbohydrates, Component.TotalSugars, Component.SimpleSugars, Component.FreeSugars, Component.Fructose, Component.Galactose, Component.Glucose, Component.Lactose, Component.Sucrose, Component.Starch, Component.TotalDietaryFibre, Component.CrudeDietaryFibre, Component.InsolubleDietaryFibre, Component.SolubleDietaryFibre, Component.VitaminA, Component.AlphaCarotene, Component.BetaCarotene, Component.GammaCarotene, Component.VitaminD, Component.VitaminE, Component.VitaminK, Component.VitaminC, Component.B1Thiamin, Component.B2Riboflavin, Component.B3Niacin, Component.B6Piridoksin, Component.B5PantothenicAcid, Component.B7Biotin, Component.B9FolicAcid, Component.B12Cobalamin, Component.Sodium, Component.Chloride, Component.Potassium, Component.Calcium, Component.Magnesium, Component.Phosphorus, Component.Iron, Component.Iodine, Component.Fluoride, Component.Zink, Component.Copper, Component.Manganese, Component.Chronium, Component.Molybdenum, Component.Proline, Component.Selenium, Component.Water, Component.Alcohol, Component.TotalOrac, Component.GlycemicIndex, Component.GlycemicLoad, Component.Color, Component.Probio, Component.Co2e, Component.Energy];

export enum CookingMethod {Unknown = 0, General = 1, NotApplicable = 2, DryHeat = 3, BakedOrRoasted = 4, BroiledOrGrilled = 5, CharcoalBroiled = 6, Griddled = 7, Microwave = 8, CookedInWaterOrWaterBasedLiquid = 9, Boiled = 10, BoiledAndDrained = 11, BoiledInLargeAmountOfLiquid = 12, BoiledInSmallAmountOfLiquid = 13, BoiledAndUndrained = 14, Braised = 15, SimmeredPoachedOrStewed = 16, CookedInSteam = 17, SteamedWithPressure = 18, SteamedWithoutPressure = 19, Sauteed = 20, StirFried = 21, DeepFried = 22, ShallowFried = 23}
export const AllCookingMethods = [CookingMethod.Unknown, CookingMethod.General, CookingMethod.NotApplicable, CookingMethod.DryHeat, CookingMethod.BakedOrRoasted, CookingMethod.BroiledOrGrilled, CookingMethod.CharcoalBroiled, CookingMethod.Griddled, CookingMethod.Microwave, CookingMethod.CookedInWaterOrWaterBasedLiquid, CookingMethod.Boiled, CookingMethod.BoiledAndDrained, CookingMethod.BoiledInLargeAmountOfLiquid, CookingMethod.BoiledInSmallAmountOfLiquid, CookingMethod.BoiledAndUndrained, CookingMethod.Braised, CookingMethod.SimmeredPoachedOrStewed, CookingMethod.CookedInSteam, CookingMethod.SteamedWithPressure, CookingMethod.SteamedWithoutPressure, CookingMethod.Sauteed, CookingMethod.StirFried, CookingMethod.DeepFried, CookingMethod.ShallowFried];
export const CookingMethodToName = new Map<CookingMethod, string>([[1, "Način toplotne obdelave neznan"], [10, "Kuhanje v vodi ali tekočini na vodni osnovi"], [11, "Kuhanje z vretjem"], [12, "Kuhanje z vretjem odcejeno"], [13, "Kuhanje z vretjem v veliki količini tekočine"], [14, "Kuhanje z vretjem v majhni količini vode"], [15, "Kuhanje z vretjem neodcejeno"], [16, "Praženje in nato dušenje"], [17, "Kuhanje na nizki temperaturi brbotanje"], [18, "Soparjenje"], [19, "Soparjenje pod pritiskom"], [2, "Splošni način toplotne obdelave kuhanje"], [20, "Soparjenje brez pritiska"], [21, "Dušenje"], [22, "Praženje v woku"], [23, "Cvrtje"], [24, "Praženje v ponvi"], [3, "Brez toplotne obdelave"], [4, "Pečenje z vročim zrakom"], [5, "Klasično pečenje"], [6, "Pečenje na žaru"], [7, "Pečenje v žerjavici"], [8, "Pečenje na rešetki"], [9, "Kuhanje z mikrovalovi"]]);

export enum Diet {CeliacDisease = 1, EggAllergy = 2, MilkAllergy = 3, LactoseIntolerance = 4, PeanutAllergy = 5, NutAllergy = 11, SoyaAllergy = 13, CeleryAllergy = 14, MustardSeedAllergy = 15, SesameSeedAllergy = 16, SulfaAllergyOrSulfiteAllergy = 17, LupinAllergy = 18, FishAllergy = 19, Crustaceans = 24, Molluscs = 33, FructoseIntolerance = 34, MetabolicSyndrom = 36, OtherChronicDiseases = 37}
export const AllDiets: Diet[] = [Diet.CeliacDisease, Diet.EggAllergy, Diet.MilkAllergy, Diet.LactoseIntolerance, Diet.PeanutAllergy, Diet.NutAllergy, Diet.SoyaAllergy, Diet.CeleryAllergy, Diet.MustardSeedAllergy, Diet.SesameSeedAllergy, Diet.SulfaAllergyOrSulfiteAllergy, Diet.LupinAllergy, Diet.FishAllergy, Diet.Crustaceans, Diet.Molluscs, Diet.FructoseIntolerance, Diet.MetabolicSyndrom, Diet.OtherChronicDiseases];
export const DietToName = new Map<Diet, string>([[1, "Brezglutenska dieta"], [11, "Alergijska dieta brez drevesnih oreškov"], [13, "Alergijska dieta brez soje"], [14, "Alergijska dieta brez listnate zelene"], [15, "Alergijska dieta brez gorčice in gorčičnih semen"], [16, "Alergijska dieta brez sezamovega semena"], [17, "Alergijska dieta brez žveplovega dioksida in sulfitov"], [18, "Alergijska dieta brez volčjega boba"], [19, "Alergijska dieta brez rib"], [2, "Alergijska dieta brez jajc"], [24, "Alergijska dieta brez rakov"], [3, "Alergijska dieta brez kravjega mleka"], [33, "Alergijska dieta brez mehkužcev"], [34, "Dieta pri fruktozni intoleranci"], [36, "Dieta pri motnjah presnove"], [37, "Dieta pri drugih kroničnih boleznih"], [4, "Dieta pri laktozni intoleranci"], [5, "Alergijska dieta brez arašidov"]]);

export type DietCombination = string;

export type Dunford = number;
export const DunfordToParent = new Map<Dunford, Dunford|null>([[1000, null], [1001, 1000], [100101, 1001], [100102, 1001], [1002, 1000], [100201, 1002], [100205, 1002], [1003, 1000], [100300, 1003], [1004, 1000], [100401, 1004], [100403, 1004], [100404, 1004], [100405, 1004], [1005, 1000], [100500, 1005], [1006, 1000], [100600, 1006], [1007, 1000], [100700, 1007], [1100, null], [1101, 1100], [110101, 1101], [110102, 1101], [110103, 1101], [110104, 1101], [1102, 1100], [110200, 1102], [1103, 1100], [110300, 1103], [1200, null], [1201, 1200], [120100, 1201], [1202, 1200], [1203, 1200], [120301, 1203], [120302, 1203], [1204, 1200], [120401, 1204], [120402, 1204], [120403, 1204], [120405, 1204], [1205, 1200], [1206, 1200], [120600, 1206], [1207, 1200], [1208, 1200], [120800, 1208], [1300, null], [1301, 1300], [130100, 1301], [1302, 1300], [130200, 1302], [1303, 1300], [130300, 1303], [1400, null], [1401, 1400], [140100, 1401], [1402, 1400], [140200, 1402], [1403, 1400], [140300, 1403], [1404, 1400], [140400, 1404], [1405, 1400], [140500, 1405], [1500, null], [1501, 1500], [150101, 1501], [150102, 1501], [150103, 1501], [150104, 1501], [1502, 1500], [150201, 1502], [150202, 1502], [150203, 1502], [150204, 1502], [1503, 1500], [150301, 1503], [150302, 1503], [150303, 1503], [150304, 1503], [150305, 1503], [1504, 1500], [150401, 1504], [150402, 1504], [1505, 1500], [150500, 1505], [1506, 1500], [150600, 1506], [1600, null], [1601, 1600], [160101, 1601], [160102, 1601], [1602, 1600], [160200, 1602], [1700, null], [1701, 1700], [170100, 1701], [1800, null], [1801, 1800], [180101, 1801], [180102, 1801], [180103, 1801], [1802, 1800], [180201, 1802], [180202, 1802], [1803, 1800], [1900, null], [1901, 1900], [190101, 1901], [190102, 1901], [190103, 1901], [1902, 1900], [190200, 1902], [2000, null], [2001, 2000], [200101, 2001], [200102, 2001], [200103, 2001], [2002, 2000], [200201, 2002], [200202, 2002], [200203, 2002], [200204, 2002], [200205, 2002], [2003, 2000], [200300, 2003], [2004, 2000], [200400, 2004], [2100, null], [2101, 2100], [210101, 2101], [210102, 2101], [210103, 2101], [210104, 2101], [2102, 2100], [210200, 2102], [2200, null], [2201, 2200], [220100, 2201], [2300, null], [2301, 2300], [230101, 2301], [230102, 2301], [230103, 2301], [2302, 2300], [230200, 2302], [2303, 2300], [230301, 2303], [230302, 2303], [230303, 2303], [230304, 2303], [2400, null], [2401, 2400], [240101, 2401], [240102, 2401], [240103, 2401], [2500, null], [2501, 2500], [250101, 2501], [250102, 2501], [250103, 2501], [250104, 2501], [250105, 2501], [250106, 2501], [250107, 2501], [250108, 2501], [2502, 2500], [2600, null], [2601, 2600], [260101, 2601]]);
export const DunfordToName = new Map<Dunford, string>([[1000, "Pijače"], [1001, "Sadni in zelenjavni sokovi"], [100101, "Sokovi"], [100102, "Nektarji"], [1002, "Brezalkoholne pijače"], [100201, "Brezalkoholne pijače"], [100205, "Energijske pijače"], [1003, "Sirupi"], [100300, "Sirupi"], [1004, "Kava in čaj"], [100401, "Čaji"], [100403, "Kava"], [100404, "Kava instant"], [100405, "Kavni pripravki"], [1005, "Izotonične pijače"], [100500, "Izotonične pijače"], [1006, "Alkoholne pijače"], [100600, "Alkoholne pijače"], [1007, "Vode"], [100700, "Vode"], [1100, "Kruh in pekovski izdelki"], [1101, "Kruh"], [110101, "Kruh"], [110102, "Hrustljavčki"], [110103, "Tortilje"], [110104, "Testo"], [1102, "Piškoti"], [110200, "Piškoti"], [1103, "Torte, mafini in pecivo"], [110300, "Torte, mafini in pecivo"], [1200, "Žita in žitni proizvodi"], [1201, "Žitne ploščice"], [120100, "Žitne ploščice"], [1202, "Rezanci"], [1203, "Žita za zajtrk"], [120301, "Žita za zajtrk"], [120302, "Kosmiči in otrobi"], [1204, "Testenine"], [120401, "Jušne zakuhe"], [120402, "Sušene testenine"], [120403, "Sveže testenine"], [120405, "Sveže polnjene testenine"], [1205, "Koruza"], [1206, "Riž"], [120600, "Riž"], [1207, "Kuskus"], [1208, "Nepredelana žita"], [120800, "Nepredelana žita"], [1300, "Slaščice"], [1301, "Čokolada in sladkarije"], [130100, "Čokolada in sladkarije"], [1302, "Žele izdelki"], [130200, "Žele izdelki"], [1303, "Žvečilni gumi"], [130300, "Žvečilni gumi"], [1400, "Predpripravljena živila"], [1401, "Pice"], [140100, "Pice"], [1402, "Juhe"], [140200, "Juhe"], [1403, "Pripravljeni obroki"], [140300, "Pripravljeni obroki"], [1404, "Predpripravljene solate in sendviči"], [140400, "Predpripravljene solate in sendviči"], [1405, "Drugo"], [140500, "Priloge"], [1500, "Mlečni izdelki"], [1501, "Siri "], [150101, "Skuta"], [150102, "Namazi in topljeni siri"], [150103, "Siri"], [150104, "Nadomestki sira"], [1502, "Jogurti"], [150201, "Navadni jogurti"], [150202, "Jogurti z okusom"], [150203, "Jogurtovi napitki z okusom"], [150204, "Nadomestki jogurtov"], [1503, "Mleko"], [150301, "Mleko"], [150302, "Nadomestki mleka"], [150303, "Mlečni napitki"], [150304, "Koncentrirano mleko"], [150305, "Instant kakav"], [1504, "Smetana"], [150401, "Smetana"], [150402, "Nadomestki smetane"], [1505, "Deserti"], [150500, "Deserti"], [1506, "Sladoledi"], [150600, "Sladoledi"], [1600, "Jedilna olja in emulzije"], [1601, "Maslo in margarina"], [160101, "Maslo"], [160102, "Margarine"], [1602, "Jedilna olja"], [160200, "Jedilna olja"], [1700, "Jajca"], [1701, "Jajca"], [170100, "Jajca"], [1800, "Ribe in ribji izdelki"], [1801, "Konzervirane ribe in morski sadeži"], [180101, "Ribe v nalivu"], [180102, "Ribe z zelenjavo"], [180103, "Ribji namazi"], [1802, "Sveže ribe"], [180201, "Nepredelane ribe"], [180202, "Predelani ribji izdelki"], [1803, "Zamrznjene ribe"], [1900, "Živila za posebne prehranske namene"], [1901, "Otroška hrana"], [190101, "Otroški napitki"], [190102, "Mlečne formule"], [190103, "Uvajalna hrana"], [1902, "Nadomestki obrokov"], [190200, "Nadomestki obrokov"], [2000, "Sadje in zelenjava"], [2001, "Zelenjava"], [200101, "Zamrznjena zelenjava"], [200102, "Vložena zelenjava"], [200103, "Sušena zelenjava"], [2002, "Sadje"], [200201, "Zamrznjeno sadje"], [200202, "Vloženo sadje"], [200203, "Sveže sadje"], [200204, "Sušeno sadje"], [200205, "Mešanice oreškov in sadja"], [2003, "Marmelade in namazi"], [200300, "Marmelade in namazi"], [2004, "Oreški in semena"], [200400, "Oreški in semena"], [2100, "Meso in mesni izdelki"], [2101, "Predelani mesni izdelki"], [210101, "Nepredelano meso"], [210102, "Predelani mesni izdelki"], [210103, "Mastni izdelki"], [210104, "Paštete"], [2102, "Nadomestki mesnih izdelkov"], [210200, "Nadomestki mesnih izdelkov"], [2200, "Prigrizki"], [2201, "Čips in razni prigrizki"], [220100, "Čips in razni prigrizki"], [2300, "Omake in namazi"], [2301, "Omake"], [230101, "Sladke omake"], [230102, "Omake za testenine"], [230103, "Druge omake"], [2302, "Majoneze/prelivi"], [230200, "Majoneze/prelivi"], [2303, "Namazi"], [230301, "Sladki namazi"], [230302, "Namazi iz oreškov"], [230303, "Rastlinski namazi"], [230304, "Ostali namazi"], [2400, "Sladkor, med in podobni izdelki"], [2401, "Med in sirupi"], [240101, "Sladkor"], [240102, "Med"], [240103, "Sirupi"], [2500, "Drugo"], [2501, "Drugo"], [250101, "Kis"], [250102, "Prehranska dopolnila"], [250103, "Začimbe"], [250104, "Aditivi"], [250105, "Ostalo"], [250106, "Mešani raznoliki paketi "], [250107, "Paketi več okusov"], [250108, "Sol"], [2502, "Drugo - sol"], [2600, "Nerazvrščeno"], [2601, "Nerazvrščeno"], [260101, "Nerazvrščeno"]]);

export type ECatalog = string;
export const eCatalogCategoryNames = new Map<string, string>([["01", "Mleko in mlečni izdelki"], ["02", "Meso in mesni izdelki"], ["03", "Kruh, pekovski in fini izdelki"], ["04", "Testenine, zakuhe, testo"], ["05", "Moke in mlevski izdelki"], ["06", "Konzervirana sadje in zelenjava"], ["07", "Zamrznjena sadje in zelenjava"], ["08", "Ribe in morski sadeži"], ["09", "Zamrznjeni izdelki"], ["10", "Med"], ["11", "Čaji"], ["12", "Začimbe"], ["13", "Olja"], ["14", "Suho sadje in oreščki"], ["15", "Jajca"], ["16", "Brezalkoholne pijače in voda"], ["17", "Čokolada in kakav"], ["18", "Sveže sadje"], ["19", "Sveža zelenjava"], ["20", "Stročnice"], ["21", "Riž"], ["22", "Kis"], ["23", "Sladoled"], ["24", "Ekološki izdelki"], ["25", "Splošno prehrambeno blago"], ["26", "Živila za posebne prehranske namene"], ["27", "Alkoholne pijače"]]);
export const eCatalogSubcategoryNames = new Map<string, string>([["01DRU", "Drugi izdelki"], ["01FEI", "Fermentirani izdelki"], ["01KOZ", "Kozje mleko in izdelki iz njega"], ["01MAS", "Maslo"], ["01MLD", "Deserti"], ["01MLE", "Mleko"], ["01MLN", "Mlečni napitki"], ["01MVP", "Mleko v prahu"], ["01NAM", "Namazi"], ["01OVČ", "Ovčje mleko in izdelki iz njega"], ["01POS", "Mleko in mlečni izdelki posebne sestave"], ["01PUD", "Mlečni pudingi"], ["01SIR", "Siri"], ["01SKU", "Skuta"], ["01SME", "Smetana"], ["02DKO", "Drobovina, kosti"], ["02MIM", "Mast in maščobni izdelki"], ["02MPR", "Mesni pripravki"], ["02MPS", "Mesni izdelki posebne sestave"], ["02NOM", "Nojevo meso in mesni izdelki"], ["02PAS", "Paštete"], ["02PMI", "Perutninski mesni izdelki"], ["02PSM", "Pasterizirane in sušene mesnine"], ["02SGT", "Sveže goveje in telečje meso"], ["02SPE", "Sveže perutninsko meso in drobovina"], ["02SSV", "Sveže svinjsko meso"], ["03DPI", "Drugi pekovski izdelki"], ["03IZP", "Izdelki posebne sestave"], ["03KEK", "Sladki fini pekovski izdelki"], ["03KRU", "Kruh"], ["03SLP", "Slano pekovsko pecivo"], ["03SPP", "Sladko pekovsko pecivo"], ["04JZA", "Jušne zakuhe"], ["04PTE", "Polnjene testenine"], ["04SHT", "Sveže hlajeno testo"], ["04SPS", "Priloge, jedi"], ["04TED", "Testenine durum"], ["04TEJ", "Testenine jajčne"], ["04TES", "Testenine specialne"], ["05DMI", "Drugi mlevski izdelki"], ["05KAS", "Kaše"], ["05KOS", "Kosmiči in musli izdelki"], ["05MOK", "Moke"], ["05ZDR", "Zdrobi in instant izdelki"], ["06DZE", "Džemi in marmelade"], ["06KSA", "Konzervirano in vloženo sadje"], ["06PRI", "Priloge in dodatki"], ["06VLZ", "Konzervirana in vložena zelenjava"], ["07SAD", "Sadje"], ["07ZEL", "Zelenjava"], ["08MEH", "Mehkužci zamrznjeni"], ["08MOR", "Morski sadeži in raki, zamrznjeni"], ["08MSR", "Morske sveže ribe"], ["08PRI", "Panirane ribe zamrznjene"], ["08RIB", "Ribe zamrznjene"], ["08RIF", "Ribji fileji zamrznjeni"], ["08RIK", "Ribe konzervirane, paštete"], ["08RPR", "Ribe prekajene, posušene"], ["08SSR", "Sladkovodne sveže ribe"], ["09SAJ", "Samostojne jedi, priloge, testo"], ["09SLP", "Sladko pecivo"], ["09SPE", "Slano pecivo"], ["10MED", "Med"], ["11CAJ", "Čaji"], ["12ZAC", "Začimbe"], ["13MAJ", "Majoneza"], ["13OLJ", "Olja"], ["13OMA", "Omake"], ["14ORE", "Oreški in mak"], ["14SSA", "Suho sadje"], ["15JAJ", "Jajca, kokošja"], ["15NJA", "Jajca, nojeva"], ["16BRA", "Brezalkoholne pijače"], ["16SIU", "Sirupi"], ["16SNE", "Sadni nektarji"], ["16SSK", "Smoothie in sadne kaše"], ["16SSO", "Sadni sokovi"], ["16SZP", "Sadno zelenjavne pijače"], ["16VOD", "Voda"], ["17COK", "Čokolada in kakav"], ["18JSS", "Južno sadje, sveže"], ["18SVS", "Sveže sadje"], ["19GOB", "Gobe"], ["19SVZ", "Sveža zelenjava"], ["20STR", "Stročnice"], ["21RIZ", "Riž"], ["22KIS", "Kis"], ["23PSL", "Sladoledi posebne sestave"], ["23SLA", "Sladoled"], ["24BIK", "Eko kis"], ["24BVI", "Eko vegetarijanski in veganski izdelki"], ["24ECA", "Eko čaji"], ["24EDE", "Eko med"], ["24EJA", "Eko jajca"], ["24EKI", "Eko konzervirana sadje in zelenjava"], ["24EKO", "Eko olja"], ["24EKP", "Eko kruh, pekovski in fini izdelki"], ["24EME", "Eko goveje in telečje meso ter mesni izdelki"], ["24EML", "Eko mleko in mlečni izdelki"], ["24EMM", "Eko moka in mlevski izdelki"], ["24ERM", "Eko ribe in morski sadeži"], ["24ESD", "Eko sveže sadje"], ["24ESO", "Eko suho sadje in oreščki"], ["24ESS", "Eko sveže stročnice"], ["24ESZ", "Eko sveža zelenjava"], ["24ETE", "Eko testenine, zakuhe in testo"], ["24EZA", "Eko začimbe"], ["24EZI", "Eko zamrznjeni izdelki"], ["24EZZ", "Eko zamrznjena zelenjava in sadje"], ["24SOK", "Eko sokovi"], ["25SPB", "Splošno prehrambeno blago"], ["26BGI", "Izdelki brez glutena"], ["26BLA", "Izdelki brez laktoze"], ["27PIV", "Pivo"], ["27VIN", "Vino"], ["27ZGP", "Žgane pijače"]]);
export const eCatalogSubcategoryToCategory = new Map<string, string>([["01DRU", "01"], ["01FEI", "01"], ["01KOZ", "01"], ["01MAS", "01"], ["01MLD", "01"], ["01MLE", "01"], ["01MLN", "01"], ["01MVP", "01"], ["01NAM", "01"], ["01OVČ", "01"], ["01POS", "01"], ["01PUD", "01"], ["01SIR", "01"], ["01SKU", "01"], ["01SME", "01"], ["02DKO", "02"], ["02MIM", "02"], ["02MPR", "02"], ["02MPS", "02"], ["02NOM", "02"], ["02PAS", "02"], ["02PMI", "02"], ["02PSM", "02"], ["02SGT", "02"], ["02SPE", "02"], ["02SSV", "02"], ["03DPI", "03"], ["03IZP", "03"], ["03KEK", "03"], ["03KRU", "03"], ["03SLP", "03"], ["03SPP", "03"], ["04JZA", "04"], ["04PTE", "04"], ["04SHT", "04"], ["04SPS", "04"], ["04TED", "04"], ["04TEJ", "04"], ["04TES", "04"], ["05DMI", "05"], ["05KAS", "05"], ["05KOS", "05"], ["05MOK", "05"], ["05ZDR", "05"], ["06DZE", "06"], ["06KSA", "06"], ["06PRI", "06"], ["06VLZ", "06"], ["07SAD", "07"], ["07ZEL", "07"], ["08MEH", "08"], ["08MOR", "08"], ["08MSR", "08"], ["08PRI", "08"], ["08RIB", "08"], ["08RIF", "08"], ["08RIK", "08"], ["08RPR", "08"], ["08SSR", "08"], ["09SAJ", "09"], ["09SLP", "09"], ["09SPE", "09"], ["10MED", "10"], ["11CAJ", "11"], ["12ZAC", "12"], ["13MAJ", "13"], ["13OLJ", "13"], ["13OMA", "13"], ["14ORE", "14"], ["14SSA", "14"], ["15JAJ", "15"], ["15NJA", "15"], ["16BRA", "16"], ["16SIU", "16"], ["16SNE", "16"], ["16SSK", "16"], ["16SSO", "16"], ["16SZP", "16"], ["16VOD", "16"], ["17COK", "17"], ["18JSS", "18"], ["18SVS", "18"], ["19GOB", "19"], ["19SVZ", "19"], ["20STR", "20"], ["21RIZ", "21"], ["22KIS", "22"], ["23PSL", "23"], ["23SLA", "23"], ["24BIK", "24"], ["24BVI", "24"], ["24ECA", "24"], ["24EDE", "24"], ["24EJA", "24"], ["24EKI", "24"], ["24EKO", "24"], ["24EKP", "24"], ["24EME", "24"], ["24EML", "24"], ["24EMM", "24"], ["24ERM", "24"], ["24ESD", "24"], ["24ESO", "24"], ["24ESS", "24"], ["24ESZ", "24"], ["24ETE", "24"], ["24EZA", "24"], ["24EZI", "24"], ["24EZZ", "24"], ["24SOK", "24"], ["25SPB", "25"], ["26BGI", "26"], ["26BLA", "26"], ["27PIV", "27"], ["27VIN", "27"], ["27ZGP", "27"]]);

export type Food = Product | Recipe;
export function isProduct(food: Food): food is Product {
  return (food as Product).producer !== undefined;
}
export function isRecipe(food: Food): food is Recipe {
  return (food as Recipe).cookingMethod !== undefined;
}

export enum FoodGroup {StarchyFoods = 1, MilkAndMilkProducts = 2, MeatAndSubstitutes = 3, Pulses = 4, Vegetables = 5, Fruit = 6, FatAndFattyFoods = 7, SugarAndSweetFoods = 8}
export const AllFoodGroups = [FoodGroup.StarchyFoods, FoodGroup.MilkAndMilkProducts, FoodGroup.MeatAndSubstitutes, FoodGroup.Pulses, FoodGroup.Vegetables, FoodGroup.Fruit, FoodGroup.FatAndFattyFoods, FoodGroup.SugarAndSweetFoods];

export enum FoodKind {Any = 0, Product = 1, Recipe = 2}

export type Gastro = number;
export const AllGastroProduct: Gastro[] = [11, 12, 15, 16, 29, 3, 35, 36, 37, 4, 5, 6, 7, 8, 9];
export const AllGastroRecipe: Gastro[] = [1, 10, 13, 14, 17, 18, 19, 2, 20, 21, 22, 23, 24, 25, 26, 27, 28, 30, 31, 32, 33, 34];
export const GastroToName = new Map<Gastro, string>([[1, "Mlečne jedi"], [10, "Ostali napitki"], [11, "Sadje"], [12, "Zelenjava"], [13, "Namazi"], [14, "Mlečni napitki"], [15, "Suho sadje"], [16, "Oreški"], [17, "Juhe"], [18, "Zrezki v omaki"], [19, "Pečeno meso"], [2, "Jajčne jedi"], [20, "Ribe in morski sadeži"], [21, "Peciva"], [22, "Pečen piščanec"], [23, "Mesne enolončnice"], [24, "Zelenjavne enolončnice"], [25, "Škrobne priloge"], [26, "Rižote"], [27, "Jedi iz testenin"], [28, "Zelenjavne prikuhe"], [29, "Kruh in pekovsko pecivo (dodatek)"], [3, "Kruh in pekovsko pecivo"], [30, "Listnate solate"], [31, "Kuhano-sveže solate"], [32, "Ostale solate"], [33, "Kompoti"], [34, "Sadne jedi"], [35, "Peciva"], [36, "Skute"], [37, "Mlečni deserti in skute s sadjem"], [4, "Drugi pekovski izdelki"], [5, "Namazi"], [6, "Maslo in margarina za namaz"], [7, "Siri"], [8, "Mesni izdelki"], [9, "Mleko, mlečni napitki in mlečni izdelki"]]);

export enum GroupType {Kindergarten = 1, ElementarySchool, MiddleSchool, Adult}
export const AllGroupTypes = [GroupType.Kindergarten, GroupType.ElementarySchool, GroupType.MiddleSchool, GroupType.Adult];

export enum MealCode {Breakfast = 1, MorningSnack = 2, Lunch = 3, AfternoonSnack = 4, Supper = 5, NightMeal = 6}
export const AllMealCodes = [MealCode.Breakfast, MealCode.MorningSnack, MealCode.Lunch, MealCode.AfternoonSnack, MealCode.Supper];

export type MealCombination = string;

export enum MealSize {KindergartenSmall = 1, KindergartenLarge, ElementarySmall, ElementaryMedium, ElementaryLarge, MiddleSmall, MiddleLarge, AdultSmall, AdultLarge}
export const AllMealSizes = [MealSize.KindergartenSmall, MealSize.KindergartenLarge, MealSize.ElementarySmall, MealSize.ElementaryMedium, MealSize.ElementaryLarge, MealSize.MiddleSmall, MealSize.MiddleLarge, MealSize.AdultSmall, MealSize.AdultLarge];

export type MenuStatus = 'bare' | 'invalid' | 'completed';

export interface Product {
  id: number;
  yearId: number;
  name: string;
  values: Values;
  edible: number;
  allergens: Allergen[];
  traceAllergens: Allergen[];
  units: Units;
  ecoRatio: number;
  dependants: number[];
  producer: string;
  supplier: string;
  ingredients: string;
  specifiedValues: Values;
  qualityScheme: QualityScheme[];
  packaging: Packaging[];
  eCatalog: ECatalog;
  dunford: number;
  nutriGroup: number;
  foodGroup: number;
}


export enum QualityScheme {EuZOP = 1, EuZGO = 2, EuZTP = 3, EuEKO = 4, NtVK = 5, NtIP = 6, NtIK = 7, NtEKO = 8, NtNMV = 9, Biodar = 10, Demeter = 11}
export const AllQualitySchemes = [QualityScheme.EuZOP, QualityScheme.EuZGO, QualityScheme.EuZTP, QualityScheme.EuEKO, QualityScheme.NtVK , QualityScheme.NtIP , QualityScheme.NtIK , QualityScheme.NtEKO, QualityScheme.NtNMV, QualityScheme.Demeter];

export interface Recipe {
  id: number;
  yearId: number;
  name: string;
  values: Values;
  edible: number;
  allergens: Allergen[];
  traceAllergens: Allergen[];
  units: Units;
  ecoRatio: number;
  dependants: number[];
  cookingMethod: CookingMethod;
  yieldGroup: string;
  yieldFactor: number;
  isDrained: boolean;
  ingredients: Ingredient[];
  seasonQuality: string;
  gastro: Gastro;
  meals: MealCombination;
  specifiedWeight: number;
  weight: number;
  diets: FoodDietStatus[];
  photos: RecipePhoto[];
  preparation?: string;
  indirectIngredients: [number, number][];
  seq?: number;
  designation?: string;
  source?: string;
  author?: string;
  ingredientMissingFoodGroup: boolean;
}


export enum Season {Spring = 1, Summer = 2, Autumn = 3, Winter = 4}
export const AllSeasons = [Season.Spring, Season.Summer, Season.Autumn, Season.Winter];

export type Unit = [Category, number];
export type Units = Unit[];

export type Value = [Component, number];
export type Values = Value[];

export interface CreateGroupRequest {
  yearId: number;
  type: GroupType;
  name: string;
  meals: GroupMealRequest[];
  diets: DietDetails[];
}

export interface GroupResponse {
  id: number;
  type: GroupType;
  name: string;
  meals: GroupMealRequest[];
  diets: DietDetails[];
}

export interface GetCalendarYearsResponse {
  yearId: number;
  year: number;
  current: boolean;
}

export interface GenerateCalendarRequest {
  yearId: number;
  fromDate: string;
  toDate: string;
}

export interface CalendarYearResponse {
  id: number;
  year: number;
  workdays: string[];
  exceptions: string[];
}

export interface GetYearMealSizesRequest {
  yearId: number;
}

export interface GetGroupExceptionsRequest {
  yearId: number;
  from?: string;
  to?: string;
}

export interface GroupExceptionsResponse {
  yearId: number;
  year: number;
  workdays: string[];
  groups: GroupResponse[];
  exceptions: GroupExceptionsException[];
  fromDate: string;
  toDate: string;
  noDietId: number;
  holidays: string[];
}

export interface GetGroupsRequest {
  yearId: number;
}

export interface Date {
  day: number;
}

export interface DietDetails {
  id: number;
  noDiet?: boolean;
  dietCodes?: Diet[];
  mealSize: MealSize;
  name?: string;
  description?: string;
}

export interface GetCalendarYearRequest {
  yearId: number;
}

export interface RemoveWorkdaysRequest {
  yearId: number;
  fromDate: string;
  toDate: string;
}

export interface UpdateExceptionRequest {
  yearId: number;
  from: string;
  to: string;
  exceptions: GroupMealException[];
}

export interface SetWorkdayRequest {
  yearId: number;
  isWorkday: boolean;
  fromDate: string;
  toDate: string;
}

export interface UpdateGroupRequest {
  id: number;
  type: GroupType;
  name: string;
  meals: GroupMealRequest[];
  diets: DietDetails[];
}

export interface AnalyzeRecipeRequest {
  yearId: number;
  cookingMethod: CookingMethod;
  ingredients: Ingredient[];
  gastro: Gastro;
  yieldFactor: number;
}

export interface AnalyzeRecipeResponse {
  finalWeight: number;
  portions: PortionEstimation[];
  allergens: Allergen[];
  traceAllergens: Allergen[];
}

export interface CreateProductRequest {
  yearId: number;
  name: string;
  eCatalog: ECatalog;
  foodGroup: number;
  producer: string;
  supplier: string;
  ingredients: string;
  specifiedValues: Values;
  qualityScheme: QualityScheme[];
  allergens: Allergen[];
  traceAllergens: Allergen[];
  newPackaging: BasePackaging[];
  foreignSource?: string;
  foreignId?: string;
  edible: number;
}

export interface FrontProduct {
  id: number;
  yearId: number;
  name: string;
  values: Values;
  edible: number;
  allergens: Allergen[];
  traceAllergens: Allergen[];
  units: Units;
  ecoRatio: number;
  dependants: number[];
  producer: string;
  supplier: string;
  ingredients: string;
  specifiedValues: Values;
  qualityScheme: QualityScheme[];
  packaging: Packaging[];
  eCatalog: ECatalog;
  dunford: number;
  nutriGroup: number;
  foodGroup: number;
  radioFoodGroups: RadioFoodGroups;
  l3FoodGroups: nutribaseFoodGroup[];
}

export interface CreateRecipeRequest {
  yearId: number;
  name: string;
  gastro: Gastro;
  diets: FoodDietStatus[];
  cookingMethod: CookingMethod;
  yieldGroup: string;
  yieldFactor: number;
  seasonQuality: string;
  specifiedWeight: number;
  ingredients: Ingredient[];
  edible: number;
  newPhoto?: string;
  preparation?: string;
  seq?: number;
  designation?: string;
  source?: string;
  author?: string;
}

export interface DeleteFoodRequest {
  yearId: number;
  foodId: number;
}

export interface DeletePackagingRequest {
  yearId: number;
  foodId: number;
  packageId: number;
}

export interface FindFoodRequest {
  yearId: number;
  mealSize?: MealSize;
  mealCode?: MealCode;
  dietId?: number;
  kind?: FoodKind;
  query?: string;
  gastro?: Gastro;
  qualityScheme?: QualityScheme;
  diet?: Diet;
  season?: Season;
  offset?: number;
  limit?: number;
  ids?: number[];
  excludeFoodId?: number;
  foodGroupId?: number;
  includeIngredients?: boolean;
  includeIncomplete?: boolean;
  onlyComplete?: boolean;
}

export interface FindFoodResponse {
  foods: BasicFood[];
  count: number;
  incompleteCount?: number;
  incompleteId: number;
}

export interface FindForeignRequest {
  source: string;
  query: string;
  offset?: number;
  limit?: number;
}

export interface FindForeignResponse {
  foods: ForeignBasicFood[];
}

export interface GetFilteredYieldGroupsRequest {
  prepMethodId: number;
}

export interface GetFilteredYieldGroupsResponse {
  yieldGroups: nutribaseYieldGroup[];
}

export interface GetFoodRequest {
  yearId: number;
  foodId: number;
}

export interface GetFoodGroupChildrenRequest {
  parentId: number;
}

export interface GetFoodGroupChildrenResponse {
  foodGroups: nutribaseFoodGroup[];
}

export interface GetForeignRequest {
  source: string;
  id: string;
}

export interface GetForeignResponse {
  source: string;
  id: string;
  product: BaseProduct;
  packaging: BasePackaging;
  eCatalogs: ECatalog[];
}

export interface BazilImportResponse {
  completed: boolean;
  foodIds: number[];
  errors: string[];
}

export interface GetYieldFactorRequest {
  yieldGroupCode: string;
  prepMethodId: number;
}

export interface GetYieldFactorResponse {
  yieldFactor: number;
  found: boolean;
}

export interface ImportForeignRequest {
  yearId: number;
  source: string;
  ids: string[];
}

export interface UpdateProductRequest {
  id: number;
  yearId: number;
  name: string;
  eCatalog: ECatalog;
  foodGroup: number;
  producer: string;
  supplier: string;
  ingredients: string;
  specifiedValues: Values;
  qualityScheme: QualityScheme[];
  allergens: Allergen[];
  traceAllergens: Allergen[];
  newPackaging: BasePackaging[];
  foreignSource?: string;
  foreignId?: string;
  edible: number;
  existingPackaging: Packaging[];
  sourceId?: number;
}

export interface UpdateRecipeRequest {
  id: number;
  yearId: number;
  name: string;
  gastro: Gastro;
  diets: FoodDietStatus[];
  cookingMethod: CookingMethod;
  yieldGroup: string;
  yieldFactor: number;
  seasonQuality: string;
  specifiedWeight: number;
  ingredients: Ingredient[];
  edible: number;
  newPhoto?: string;
  preparation?: string;
  seq?: number;
  designation?: string;
  source?: string;
  author?: string;
  removedPhoto?: boolean;
}

export interface FrontRecipe {
  id: number;
  yearId: number;
  name: string;
  values: Values;
  edible: number;
  allergens: Allergen[];
  traceAllergens: Allergen[];
  units: Units;
  ecoRatio: number;
  dependants: number[];
  cookingMethod: CookingMethod;
  yieldGroup: string;
  yieldFactor: number;
  isDrained: boolean;
  ingredients: Ingredient[];
  seasonQuality: string;
  gastro: Gastro;
  meals: MealCombination;
  specifiedWeight: number;
  weight: number;
  diets: FoodDietStatus[];
  photos: RecipePhoto[];
  preparation?: string;
  indirectIngredients: [number, number][];
  seq?: number;
  designation?: string;
  source?: string;
  author?: string;
  ingredientMissingFoodGroup: boolean;
  prepMethods: nutribasePrepMethod[];
  yieldGroups: nutribaseYieldGroup[];
}

export interface ConfirmAllMenuDayDiet {
  yearId: number;
  date: string;
  mealSize: MealSize;
  dietId: number;
  targetMealSize?: MealSize;
  confirm: boolean;
}

export interface GetMenuDayResponse {
  yearId: number;
  datePages: DatePages;
  foods: MenuMealFood[];
  size: MealSize;
  dietId: number;
  sizes: MealSize[];
  diets: DietDetails[];
  availableMeals: MealCode[];
  mealNutritions: MenuMealNutrition[];
  mealGuidelines: MenuSizeGuidelines;
  dayDietStatuses: MenuDietStatus[];
  workdays: string[];
  favorites: FavoriteMeal[];
  canUnconfirm: boolean;
  canConfirmAllSizes: boolean;
  canUnconfirmAllSizes: boolean;
  canConfirmAllDiets: boolean;
  canUnconfirmAllDiets: boolean;
}

export interface ConfirmMenuDayDiet {
  yearId: number;
  date: string;
  mealSize: MealSize;
  dietId: number;
}

export interface CopyFavoriteMealRequest {
  yearId: number;
  date: string;
  mealSize: MealSize;
  mealCode: MealCode;
  dietId: number;
  favoriteMeal: FavoriteMeal;
}

export interface CopyMenuMealRequest {
  yearId: number;
  date: string;
  sourceSize: MealSize;
  targetSize: MealSize;
  mealCode: MealCode;
  dietId: number;
}

export interface CopyMenuMealFromRequest {
  sourceYearId: number;
  sourceDate: string;
  sourceSize: MealSize;
  targetYearId: number;
  targetDate: string;
  targetSize: MealSize;
  targetDietId: number;
}

export interface CopyMenusRequest {
  sourceYearId: number;
  targetYearId: number;
  startDate: string;
  sourceDates: string[];
  mealSize?: MealSize;
}

export interface GetMenuMonthResponse {
  yearId: number;
  selectedYear: number;
  selectedMonth: number;
  selectedSize: MealSize;
  dayStatuses: MenuDayStatus[];
  sizeStatuses: MenuSizeStatus[];
  dayNutrients: MenuDayNutrition[];
  menuGuidelines: MenuSizeGuidelines;
  availableSizes: MealSize[];
  availableMeals: MealCode[];
  prevMonth?: number;
  nextMonth?: number;
  diets: DietDetails[];
  availableYears: MenuYearSizes[];
}

export interface FavoriteMealRequest {
  yearId: number;
  date: string;
  mealSize: MealSize;
  mealCode: MealCode;
  dietId: number;
  title: string;
  recSeasons: Season[];
}

export interface FavoriteMeal {
  date: string;
  workdayId: number;
  mealSize: MealSize;
  mealCode: MealCode;
  dietId: number;
  title: string;
  recSeasons: Season[];
  foods: string[];
}

export interface GetCopyAvailableMealsRequest {
  yearId: number;
  month: number;
}

export interface GetCopyAvailableMealsResponse {
  year: number;
  month: number;
  availableDates: string[];
}

export interface GetCopyAvailableMealsForDateRequest {
  yearId: number;
  date: string;
}

export interface GetCopyAvailableMealsForDateResponse {
  meals: CopyAvailableMeal[];
}

export interface GetFavoriteMealsRequest {
  yearId: number;
  mealSize: MealSize;
  dietId: number;
}

export interface GetMenuDayRequest {
  yearId: number;
  date: string;
  size?: MealSize;
  dietId?: number;
}

export interface GetMenuMonthRequest {
  yearId: number;
  month: number;
  mealSize?: MealSize;
}

export interface GetMenuReportResponse {
  fileContent: string;
  fileName: string;
}

export interface GetMenuWeekRequest {
  yearId: number;
  week: number;
  mealSize?: MealSize;
}

export interface GetMenuWeekResponse {
  year: number;
  yearId: number;
  week: number;
  startDate: string;
  foods: MenuMealFood[];
  menuNutrients: MenuDayNutrition[];
  dayStatuses: MenuDayStatus[];
  sizeStatuses: MenuSizeStatus[];
  selectedSize: MealSize;
  selectedDietId: number;
  availableSizes: MealSize[];
  availableMeals: MealCode[];
  availableDiets: DietDetails[];
  menuGuidelines: MenuSizeGuidelines;
  prevWeek?: number;
  nextWeek?: number;
}

export interface GetShoppingListRequest {
  yearId: number;
  week: number;
}

export interface GetShoppingListResponse {
  yearId: number;
  week: number;
  products: ShoppingListProduct[];
  totalCost: number;
  startDate: string;
  prevWeek: number;
  nextWeek: number;
  workDates: string[];
  allWorkDates: string[];
}

export interface RemoveMenuDayFoodsRequest {
  yearId: number;
  date: string;
  mealSize: MealSize;
  dietId: number;
}

export interface RemoveMenuFoodRequest {
  yearId: number;
  date: string;
  mealCode: MealCode;
  mealSize: MealSize;
  dietId: number;
  foodId: number;
}

export interface RemoveMenuMealFoodsRequest {
  yearId: number;
  date: string;
  mealSize: MealSize;
  dietId: number;
  mealCode: MealCode;
}

export interface ReplaceShoppingProductRequest {
  yearId: number;
  week: number;
  oldProductId: number;
  newProductId: number;
}

export interface SetMenuFoodRequest {
  yearId: number;
  date: string;
  mealCode: MealCode;
  mealSize: MealSize;
  dietId: number;
  foodId: number;
  amount: number;
}

export interface SetShoppingListPackageCountRequest {
  yearId: number;
  week: number;
  productId: number;
  packageId: number;
  count: number;
}

export interface UnfavoriteMealRequest {
  yearId: number;
  date: string;
  mealSize: MealSize;
  mealCode: MealCode;
  dietId: number;
}

export interface UnfavoriteMealResponse {
}

export interface CreateOrganisationRequest {
  name: string;
  vatNumber?: string;
  logo: string;
}

export interface Organisation {
  id: number;
  name: string;
  vatNumber?: string;
  createdAt: string;
  currentYear: number;
  users: User[];
  logoUrl: string;
}

export interface CreateUserRequest {
  organisationId: number;
  name: string;
  email: string;
  role: string;
}

export interface SetCurrentYearRequest {
  ids: number[];
  year: number;
}

export interface UpdateOrganisationRequest {
  id: number;
  name: string;
  vatNumber?: string;
  logo: string;
  removeLogo: boolean;
}

export interface UpdateUserRequest {
  id: number;
  name: string;
  email: string;
  role: string;
}

export interface ActivateRequest {
  jwt: string;
  password: string;
}

export interface UserResponse {
  id: number;
  name: string;
  email: string;
  role: string;
  organisationId: number;
  organisationName: string;
  yearId: number;
  jwtRefreshAt: number;
  energyUnit: string;
}

export interface LoginRequest {
  email: string;
  password: string;
}

export interface LostPasswordRequest {
  email: string;
}

export interface BugReportRequest {
  email: string;
  subject: string;
  description: string;
  attachments?: BugReportAttachment[];
}

export interface UpdateUserProfile {
  name: string;
  email: string;
  energyUnit: string;
}

export interface WelcomeResponse {
  yearId: number;
  users: number;
  products: number;
  recipes: number;
}

export interface Packaging {
  id: number;
  divisible: boolean;
  amount: number;
  barcode: string;
  basePrice: number;
  tax: number;
  deductable: number;
  active: boolean;
  sourceId?: number;
}

export interface Ingredient {
  food: number;
  weight: number;
  onlyEdible: boolean;
  wholeWheat: boolean;
  soaked: boolean;
}

export interface FoodDietStatus {
  dietId: number;
  approved: boolean;
}

export interface RecipePhoto {
  id: string;
  type: string;
}

export interface GroupMealRequest {
  size: MealSize;
  meal: MealCode;
  dietIndex: number;
  count: number;
}

export interface GroupExceptionsException {
  size: MealSize;
  meal: MealCode;
  dietId: number;
  count: number;
  groupId: number;
  min: number;
  max: number;
}

export interface GroupMealException {
  size: MealSize;
  meal: MealCode;
  dietId: number;
  count: number;
  groupId: number;
}

export interface PortionEstimation {
  size: MealSize;
  weight: number;
}

export interface BasePackaging {
  divisible: boolean;
  amount: number;
  barcode: string;
  basePrice: number;
  tax: number;
  deductable: number;
  active: boolean;
  sourceId?: number;
}

export interface RadioFoodGroups {
  radioFoodGroupsL1: nutribaseFoodGroup[];
  radioFoodGroupsL2: nutribaseFoodGroup[];
  radioFoodGroupsL3: nutribaseFoodGroup[];
}

export interface nutribaseFoodGroup {
  id: number;
  level: number;
  FGNM: string;
  INCLUDE: string;
  EXCLUDE: string;
  selected: boolean;
}

export interface BasicFood {
  id: number;
  kind: FoodKind;
  name: string;
  category: Category;
  componentTotalCarbohydrates: number;
  componentProtein: number;
  componentFat: number;
  componentEnergy: number;
  ingredients: string[];
  guide?: number[];
  packages?: number[];
  isIncomplete?: boolean;
  isDietUnconfirmed?: boolean;
  missingGroup?: boolean;
}

export interface ForeignBasicFood {
  id: string;
  source: string;
  name: string;
  category?: Category;
  componentTotalCarbohydrates?: number;
  componentProtein?: number;
  componentFat?: number;
  barcode?: string;
}

export interface nutribaseYieldGroup {
  code: string;
  bognar_food_group_slo: string;
  bognar_sub_food_group_slo: string;
  ingredient_slo: string;
}

export interface BaseProduct {
  name: string;
  values: Values;
  edible: number;
  allergens: Allergen[];
  traceAllergens: Allergen[];
  units: Units;
  ecoRatio: number;
  dependants: number[];
  producer: string;
  supplier: string;
  ingredients: string;
  specifiedValues: Values;
  qualityScheme: QualityScheme[];
  packaging: Packaging[];
  eCatalog: ECatalog;
  dunford: number;
  nutriGroup: number;
  foodGroup: number;
}

export interface nutribasePrepMethod {
  id: number;
  EU_CODE: string;
  DESCRIPTOR: string;
}

export interface DatePages {
  date: string;
  prev?: string;
  next?: string;
}

export interface MenuMealFood {
  date: string;
  mealSize: MealSize;
  dietId: number;
  mealCode: MealCode;
  foodId: number;
  weight: number;
  energy: number;
  totalCarbohydrates?: number;
  protein?: number;
  fat?: number;
  name: string;
}

export interface MenuMealNutrition {
  mealCode: MealCode;
  values: Values;
  units: Units;
}

export interface MenuSizeGuidelines {
  minDayEnergy: number;
  maxDayEnergy: number;
  mealEnergy: MealEnergyGuideline[];
  components: ComponentGuideline[];
  categories: CategoryGuideline[];
}

export interface MenuDietStatus {
  date: string;
  size: MealSize;
  dietId: number;
  status: MenuStatus;
}

export interface MenuDayStatus {
  date: string;
  status: MenuStatus;
}

export interface MenuSizeStatus {
  size: MealSize;
  status: MenuStatus;
}

export interface MenuDayNutrition {
  date: string;
  values: Values;
  units: Units;
  categories: Units;
}

export interface MenuYearSizes {
  yearId: number;
  year: number;
  availableSizes: MealSize[];
}

export interface CopyAvailableMeal {
  mealSize: MealSize;
  mealCode: MealCode;
  foods: string[];
}

export interface ShoppingListProduct {
  id: number;
  name: string;
  producer: string;
  supplier: string;
  foodGroup: string;
  targetWeight: number;
  difference: number;
  cost: number;
  packaging: ShoppingListPackaging[];
}

export interface User {
  id: number;
  name: string;
  email: string;
  role: string;
  activated: boolean;
  createdAt: string;
}

export interface BugReportAttachment {
  filename: string;
  content: number[];
  mimeType: string;
}

export interface MealEnergyGuideline {
  mealCode: MealCode;
  min: number;
  max: number;
}

export interface ComponentGuideline {
  component: Component;
  min: number;
  max: number;
}

export interface CategoryGuideline {
  category: Category;
  min: number;
  max: number;
}

export interface ShoppingListPackaging {
  id: number;
  divisible: boolean;
  amount: number;
  count: number;
  price: number;
}


export abstract class AbstractApiService {

  protected abstract _rpc<T, V>(name: string, params?: T): Observable<V>;

  calendarCreateGroup(params: CreateGroupRequest) {
    return this._rpc<CreateGroupRequest, GroupResponse>('Calendar.CreateGroup', params);
  }

  calendarCreateYear(params: number) {
    return this._rpc<number, GetCalendarYearsResponse[]>('Calendar.CreateYear', params);
  }

  calendarDeleteGroup(params: number) {
    return this._rpc<number, void>('Calendar.DeleteGroup', params);
  }

  calendarGenerate(params: GenerateCalendarRequest) {
    return this._rpc<GenerateCalendarRequest, CalendarYearResponse>('Calendar.Generate', params);
  }

  calendarGetAvailableMealSizesForYear(params: GetYearMealSizesRequest) {
    return this._rpc<GetYearMealSizesRequest, MealSize[]>('Calendar.GetAvailableMealSizesForYear', params);
  }

  calendarGetGroupExceptions(params: GetGroupExceptionsRequest) {
    return this._rpc<GetGroupExceptionsRequest, GroupExceptionsResponse>('Calendar.GetGroupExceptions', params);
  }

  calendarGetGroups(params: GetGroupsRequest) {
    return this._rpc<GetGroupsRequest, GroupResponse[]>('Calendar.GetGroups', params);
  }

  calendarGetNextWorkday(params: number) {
    return this._rpc<number, string>('Calendar.GetNextWorkday', params);
  }

  calendarGetUsedDiets(params: number) {
    return this._rpc<number, DietDetails[]>('Calendar.GetUsedDiets', params);
  }

  calendarGetYear(params: GetCalendarYearRequest) {
    return this._rpc<GetCalendarYearRequest, CalendarYearResponse>('Calendar.GetYear', params);
  }

  calendarGetYears() {
    return this._rpc<void, GetCalendarYearsResponse[]>('Calendar.GetYears');
  }

  calendarRemoveWorkdays(params: RemoveWorkdaysRequest) {
    return this._rpc<RemoveWorkdaysRequest, CalendarYearResponse>('Calendar.RemoveWorkdays', params);
  }

  calendarSetGroupExceptions(params: UpdateExceptionRequest) {
    return this._rpc<UpdateExceptionRequest, GroupExceptionsResponse>('Calendar.SetGroupExceptions', params);
  }

  calendarSetWorkday(params: SetWorkdayRequest) {
    return this._rpc<SetWorkdayRequest, GroupExceptionsResponse>('Calendar.SetWorkday', params);
  }

  calendarUpdateGroup(params: UpdateGroupRequest) {
    return this._rpc<UpdateGroupRequest, GroupResponse>('Calendar.UpdateGroup', params);
  }

  foodAnalyzeRecipe(params: AnalyzeRecipeRequest) {
    return this._rpc<AnalyzeRecipeRequest, AnalyzeRecipeResponse>('Food.AnalyzeRecipe', params);
  }

  foodCreateProduct(params: CreateProductRequest) {
    return this._rpc<CreateProductRequest, FrontProduct>('Food.CreateProduct', params);
  }

  foodCreateRecipe(params: CreateRecipeRequest) {
    return this._rpc<CreateRecipeRequest, Recipe>('Food.CreateRecipe', params);
  }

  foodDeleteFood(params: DeleteFoodRequest) {
    return this._rpc<DeleteFoodRequest, string>('Food.DeleteFood', params);
  }

  foodDeletePackaging(params: DeletePackagingRequest) {
    return this._rpc<DeletePackagingRequest, void>('Food.DeletePackaging', params);
  }

  foodFindFood(params: FindFoodRequest) {
    return this._rpc<FindFoodRequest, FindFoodResponse>('Food.FindFood', params);
  }

  foodFindForeign(params: FindForeignRequest) {
    return this._rpc<FindForeignRequest, FindForeignResponse>('Food.FindForeign', params);
  }

  foodGetFilteredYieldGroups(params: GetFilteredYieldGroupsRequest) {
    return this._rpc<GetFilteredYieldGroupsRequest, GetFilteredYieldGroupsResponse>('Food.GetFilteredYieldGroups', params);
  }

  foodGetFood(params: GetFoodRequest) {
    return this._rpc<GetFoodRequest, Food>('Food.GetFood', params);
  }

  foodGetFoodGroupChildren(params: GetFoodGroupChildrenRequest) {
    return this._rpc<GetFoodGroupChildrenRequest, GetFoodGroupChildrenResponse>('Food.GetFoodGroupChildren', params);
  }

  foodGetForeign(params: GetForeignRequest) {
    return this._rpc<GetForeignRequest, GetForeignResponse>('Food.GetForeign', params);
  }

  foodGetImportResult(params: number) {
    return this._rpc<number, BazilImportResponse>('Food.GetImportResult', params);
  }

  foodGetYieldFactor(params: GetYieldFactorRequest) {
    return this._rpc<GetYieldFactorRequest, GetYieldFactorResponse>('Food.GetYieldFactor', params);
  }

  foodImportForeign(params: ImportForeignRequest) {
    return this._rpc<ImportForeignRequest, number>('Food.ImportForeign', params);
  }

  foodUpdateProduct(params: UpdateProductRequest) {
    return this._rpc<UpdateProductRequest, FrontProduct>('Food.UpdateProduct', params);
  }

  foodUpdateRecipe(params: UpdateRecipeRequest) {
    return this._rpc<UpdateRecipeRequest, FrontRecipe>('Food.UpdateRecipe', params);
  }

  menuConfirmAllDiets(params: ConfirmAllMenuDayDiet) {
    return this._rpc<ConfirmAllMenuDayDiet, GetMenuDayResponse>('Menu.ConfirmAllDiets', params);
  }

  menuConfirmDiet(params: ConfirmMenuDayDiet) {
    return this._rpc<ConfirmMenuDayDiet, GetMenuDayResponse>('Menu.ConfirmDiet', params);
  }

  menuCopyFavoriteMeal(params: CopyFavoriteMealRequest) {
    return this._rpc<CopyFavoriteMealRequest, GetMenuDayResponse>('Menu.CopyFavoriteMeal', params);
  }

  menuCopyMenuMeal(params: CopyMenuMealRequest) {
    return this._rpc<CopyMenuMealRequest, GetMenuDayResponse>('Menu.CopyMenuMeal', params);
  }

  menuCopyMenuMealFrom(params: CopyMenuMealFromRequest) {
    return this._rpc<CopyMenuMealFromRequest, GetMenuDayResponse>('Menu.CopyMenuMealFrom', params);
  }

  menuCopyMenus(params: CopyMenusRequest) {
    return this._rpc<CopyMenusRequest, GetMenuMonthResponse>('Menu.CopyMenus', params);
  }

  menuFavoriteMeal(params: FavoriteMealRequest) {
    return this._rpc<FavoriteMealRequest, FavoriteMeal>('Menu.FavoriteMeal', params);
  }

  menuGetCopyAvailableMeals(params: GetCopyAvailableMealsRequest) {
    return this._rpc<GetCopyAvailableMealsRequest, GetCopyAvailableMealsResponse>('Menu.GetCopyAvailableMeals', params);
  }

  menuGetCopyAvailableMealsForDate(params: GetCopyAvailableMealsForDateRequest) {
    return this._rpc<GetCopyAvailableMealsForDateRequest, GetCopyAvailableMealsForDateResponse>('Menu.GetCopyAvailableMealsForDate', params);
  }

  menuGetFavoriteMeals(params: GetFavoriteMealsRequest) {
    return this._rpc<GetFavoriteMealsRequest, FavoriteMeal[]>('Menu.GetFavoriteMeals', params);
  }

  menuGetMenuDay(params: GetMenuDayRequest) {
    return this._rpc<GetMenuDayRequest, GetMenuDayResponse>('Menu.GetMenuDay', params);
  }

  menuGetMenuMonthReport(params: GetMenuMonthRequest) {
    return this._rpc<GetMenuMonthRequest, GetMenuReportResponse>('Menu.GetMenuMonthReport', params);
  }

  menuGetMenuWeek(params: GetMenuWeekRequest) {
    return this._rpc<GetMenuWeekRequest, GetMenuWeekResponse>('Menu.GetMenuWeek', params);
  }

  menuGetMenuWeekReport(params: GetMenuWeekRequest) {
    return this._rpc<GetMenuWeekRequest, GetMenuReportResponse>('Menu.GetMenuWeekReport', params);
  }

  menuGetMenuYear(params: GetMenuMonthRequest) {
    return this._rpc<GetMenuMonthRequest, GetMenuMonthResponse>('Menu.GetMenuYear', params);
  }

  menuGetShoppingList(params: GetShoppingListRequest) {
    return this._rpc<GetShoppingListRequest, GetShoppingListResponse>('Menu.GetShoppingList', params);
  }

  menuRemoveDayFoods(params: RemoveMenuDayFoodsRequest) {
    return this._rpc<RemoveMenuDayFoodsRequest, GetMenuDayResponse>('Menu.RemoveDayFoods', params);
  }

  menuRemoveFood(params: RemoveMenuFoodRequest) {
    return this._rpc<RemoveMenuFoodRequest, GetMenuDayResponse>('Menu.RemoveFood', params);
  }

  menuRemoveMealFoods(params: RemoveMenuMealFoodsRequest) {
    return this._rpc<RemoveMenuMealFoodsRequest, GetMenuDayResponse>('Menu.RemoveMealFoods', params);
  }

  menuReplaceShoppingProduct(params: ReplaceShoppingProductRequest) {
    return this._rpc<ReplaceShoppingProductRequest, GetShoppingListResponse>('Menu.ReplaceShoppingProduct', params);
  }

  menuSetFood(params: SetMenuFoodRequest) {
    return this._rpc<SetMenuFoodRequest, GetMenuDayResponse>('Menu.SetFood', params);
  }

  menuSetFoodForAllSizes(params: SetMenuFoodRequest) {
    return this._rpc<SetMenuFoodRequest, GetMenuDayResponse>('Menu.SetFoodForAllSizes', params);
  }

  menuSetShoppingPackageCount(params: SetShoppingListPackageCountRequest) {
    return this._rpc<SetShoppingListPackageCountRequest, GetShoppingListResponse>('Menu.SetShoppingPackageCount', params);
  }

  menuUnfavoriteMeal(params: UnfavoriteMealRequest) {
    return this._rpc<UnfavoriteMealRequest, UnfavoriteMealResponse>('Menu.UnfavoriteMeal', params);
  }

  organisationCreateOrganisation(params: CreateOrganisationRequest) {
    return this._rpc<CreateOrganisationRequest, Organisation[]>('Organisation.CreateOrganisation', params);
  }

  organisationCreateUser(params: CreateUserRequest) {
    return this._rpc<CreateUserRequest, Organisation[]>('Organisation.CreateUser', params);
  }

  organisationGetOrganisations() {
    return this._rpc<void, Organisation[]>('Organisation.GetOrganisations');
  }

  organisationImpersonateUser(params: number) {
    return this._rpc<number, void>('Organisation.ImpersonateUser', params);
  }

  organisationSendActivationEmail(params: number) {
    return this._rpc<number, void>('Organisation.SendActivationEmail', params);
  }

  organisationSetCurrentYear(params: SetCurrentYearRequest) {
    return this._rpc<SetCurrentYearRequest, Organisation[]>('Organisation.SetCurrentYear', params);
  }

  organisationUpdateOrganisation(params: UpdateOrganisationRequest) {
    return this._rpc<UpdateOrganisationRequest, Organisation[]>('Organisation.UpdateOrganisation', params);
  }

  organisationUpdateUser(params: UpdateUserRequest) {
    return this._rpc<UpdateUserRequest, Organisation[]>('Organisation.UpdateUser', params);
  }

  userActivate(params: ActivateRequest) {
    return this._rpc<ActivateRequest, UserResponse>('User.Activate', params);
  }

  userLogin(params: LoginRequest) {
    return this._rpc<LoginRequest, UserResponse>('User.Login', params);
  }

  userLogout() {
    return this._rpc<void, void>('User.Logout');
  }

  userLostPassword(params: LostPasswordRequest) {
    return this._rpc<LostPasswordRequest, void>('User.LostPassword', params);
  }

  userMe() {
    return this._rpc<void, UserResponse>('User.Me');
  }

  userSendBugReport(params: BugReportRequest) {
    return this._rpc<BugReportRequest, void>('User.SendBugReport', params);
  }

  userUpdateProfile(params: UpdateUserProfile) {
    return this._rpc<UpdateUserProfile, UserResponse>('User.UpdateProfile', params);
  }

  userWelcome(params: number) {
    return this._rpc<number, WelcomeResponse>('User.Welcome', params);
  }

}
